import styled from "@emotion/styled";
import { Box, Button, Grid, Typography } from "@mui/material";

const Main = styled(Box)`
  .planContainer {
    display: flex;
    background-color: #e2e2e2;
    padding: 15px;
    gap: 10px;
  }

  @media (max-width: 600px) {
    .planContainer {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export default function SignaturesListModal({ data }) {
  return (
    <Main
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection="column"
      mb={1}
    >
      <Grid container alignItems={"center"} spacing={2}>
        <Grid item xs={12}>
          <Box textAlign={"center"}>
            <Typography variant="title" color={"primary"}>
              {data?.length === 1 ? "FIRMA TU CONTRATO" : "FIRMA TUS CONTRATOS"}
            </Typography>
          </Box>
        </Grid>
        {data[0] && (
          <Grid item xs={12}>
            <Box className="planContainer">
              <Typography>
                {data[0]?.plan} para {data[0]?.name_member}
              </Typography>
              <a href={data[0].url}>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ height: "100%" }}
                >
                  {"Firmar"}
                </Button>
              </a>
            </Box>
          </Grid>
        )}
        {/* {data?.map((item) => (
          <>
            <Grid item xs={12}>
              <Box className="planContainer">
                <Typography>
                  {item?.plan} para {item?.name_member}
                </Typography>
                <a href={item.url}>
                  <Button
                    color="primary"
                    variant="contained"
                    style={{ height: "100%" }}
                  >
                    {"Firmar"}
                  </Button>
                </a>
              </Box>
            </Grid>
          </>
        ))} */}
      </Grid>
    </Main>
  );
}
